import { useCallback, useEffect, useState } from "react";
import { getLineOfWork } from "../../services/roleService";

const useLineOfWork = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getLineOfWork();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default useLineOfWork;
